import { FC } from 'react';
import { Input } from 'antd';

interface FeedbackItemProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const FeedbackItem: FC<FeedbackItemProps> = ({
  label,
  value,
  onChange,
  placeholder = 'Type your comment...',
}) => {
  return (
    <div className="flex flex-col gap-2">
      <label className="[font-size:var(--font-l4)] lg:[font-size:var(--font-l2)] font-semibold text-(--neutral-black-NB1000)">
        {label}
      </label>
      <Input.TextArea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={3}
        className="resize-none! bg-(--neutral-white-NW1000) border border-(--neutral-black-NB200) rounded-lg!"
      />
    </div>
  );
};
